import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";

export default function Breadcrumb({ items }) {
  return (
    <nav
      data-testid="breadcrumb"
      className="flex items-center gap-2 text-xs text-foreground/60 font-mono uppercase tracking-wider"
    >
      {items.map((it, i) => (
        <span key={`${it.label}-${i}`} className="inline-flex items-center gap-2">
          {i > 0 && <CaretRight size={10} className="text-foreground/30" />}
          {it.to ? (
            <Link to={it.to} className="hover:text-foreground transition-colors duration-200">
              {it.label}
            </Link>
          ) : (
            <span className="text-foreground">{it.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
